import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { forkJoin, from, Observable, of } from 'rxjs';
import { map, switchMap, catchError, concatMap, toArray, mergeMap } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { PumpSystemItem } from '../../display-product-data/pump-systems/pump-system.model';

const BASE_URL = environment.pumpDataUrl; // replace with real API base

export interface Item {
  uuid: string;
  name: string;
}

@Injectable({ providedIn: 'root' })
export class PumpSystemService {
  constructor(private http: HttpClient) {}

  private fetchAll<T>(endpoint: string): Observable<T[]> {
    return this.http.get<T[]>(`${BASE_URL}/${endpoint}`);
  }

  private buildLookup(items: Item[]): Record<string, string> {
    const map: Record<string, string> = {};
    items.forEach((item) => {
      map[item.name] = item.uuid;
    });
    return map;
  }

  updatePumpSystems(): Observable<string[]> {
    return forkJoin({
      pumpSystems: this.fetchAll<PumpSystemItem>('pumpsystems?ignoreStatuses=STATE_4'),
      /* controllers: this.fetchAll<Item>('controllers'),
      motors: this.fetchAll<Item>('motors'),
      pumpEnds: this.fetchAll<Item>('pumpends'), */
    }).pipe(
      switchMap(({ pumpSystems }) => {
       /*  const controllerLookup = this.buildLookup(controllers);
        const motorLookup = this.buildLookup(motors);
        const pumpEndLookup = this.buildLookup(pumpEnds);
        console.log('Lookups built:', { controllerLookup, motorLookup, pumpEndLookup }); */

        return from(pumpSystems).pipe(
          concatMap((ps) =>
          this.http.get<PumpSystemItem>(`${BASE_URL}/ps/${ps.uuid}`).pipe(
            switchMap((details) => {
              details = JSON.parse(details.message)
              const version = details.versions[0] || 0;

              //details = version;
              console.log(`Fetched details for ${ps.uuid}:`, version);
              if (!version.motor.uuid && !version.controller.uuid && !version.pump_end.uuid) {
                console.log(`Skipping ${ps.uuid}: no relevant fields to update`);
                return of(`ℹ️ No update needed for ${ps.uuid}`);
              }
              const motorUuid = version.motor.uuid;
              const controllerUuid = version.controller.uuid;
              const pumpEndUuid = version.pump_end.uuid;
              /* const accessories = JSON.parse(version.accessories || []);
              version.accessories = accessories;
 */
              console.log(`Processing ${ps.uuid}:`, { "motor_name": details.motor_name, "controller": details.controller, "pump_end_name": details.pump_end_name });
              if (!motorUuid || !controllerUuid || !pumpEndUuid) {
                console.warn(`Skipping ${ps.uuid}: could not resolve all UUIDs`);
                return of(`⚠️ Skipped ${ps.uuid}`);
              }

               const updatePayload = {
                ...version,
                uuid: ps.uuid,
                name: ps.name,
                motor_uuid: motorUuid,
                controller_uuid: controllerUuid,
                pump_end_uuid: pumpEndUuid,
              };

              return /* of(updatePayload)// */this.http.put(`${BASE_URL}ps/`, updatePayload, { responseType: 'text' as 'json' } ).pipe(map(() => `✅ Updated pump system ${ps.uuid}`));
            }),
            //mergeMap(pumpSystem => this.http.put(`${BASE_URL}ps/`, pumpSystem, { responseType: 'text' as 'json' } ).pipe(map(() => `✅ Updated pump system ${ps.uuid}`)), 4),
            catchError((err) => {
              console.error(`❌ Failed to update ${ps.uuid}`, err);
              return of(`❌ Failed ${ps.uuid}`);;
            })
          )
        ), toArray());

      })
    );
  }
}
